module.exports = __webpack_public_path__ + "media/images/wishCollectorLogoOfficialBlackTrans-08e3b91a.png";